<template>
  <div class="admin-analysis-tako-root">
    <div style="margin-bottom: 20px; font-size: 0px">
      <div class="topdiv-wrapper">
        <div class="topdivcss" style="margin-left: 0px">
          <div class="toptitledivcss">接入游戏</div>
          <div class="toptitlenumdivcss">{{ projects }}</div>
        </div>
      </div>
      <div class="topdiv-wrapper">
        <div class="topdivcss">
          <div class="toptitledivcss">活跃用户数</div>
          <div class="toptitlenumdivcss">{{ activeuser }}</div>
        </div>
      </div>
      <div class="topdiv-wrapper">
        <div class="topdivcss">
          <div class="toptitledivcss">总下载量</div>
          <div class="toptitlenumdivcss">{{ totaldown }}</div>
        </div>
      </div>
      <div class="topdiv-wrapper">
        <div class="topdivcss">
          <div class="toptitledivcss">总上传量</div>
          <div class="toptitlenumdivcss">{{ totalupload }}</div>
        </div>
      </div>
      <div class="topdiv-wrapper">
        <div class="topdivcss" style="margin-right: 0px">
          <div class="toptitledivcss">存储使用量</div>
          <div class="toptitlenumdivcss">
            {{ size }}<span class="toptitlenumdivapsncss">{{ magnitude }}</span>
          </div>
        </div>
      </div>
    </div>
    <el-row :gutter="20" style="margin-top: 20px">
      <el-col :span="12">
        <AnalysisPie chartid="takopieleft" wzbj="pieleft" :piedata="modeldata" titlename="平台比例分布" />
      </el-col>
      <el-col :span="12">
        <AnalysisPie chartid="takopieright" wzbj="pieright" :piedata="modeldata" titlename="机型比例分布" />
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import { apiGetTakoAnalysis } from "@/Api/AppApi";
import AnalysisPie from "@/Components/AnalysisPie.vue";
import { onMounted, ref } from "vue";

onMounted(async () => {
  const res = await apiGetTakoAnalysis();
  if (res.code === 0) {
    reloadData(res.data);
  }
});

const projects = ref('');
const activeuser = ref('');
const totaldown = ref('');
const totalupload = ref('');
const size = ref('');
const magnitude = ref('');
const modeldata = ref(null);
function reloadData(data) {
  projects.value = toThousands(data.projects);
  activeuser.value = toThousands(data.activeuser);
  totaldown.value = toThousands(data.totaldown);
  totalupload.value = toThousands(data.totalupload);
  const storage = data.storage;
  size.value = toThousands(Number(storage.substr(0, storage.length - 1)));
  magnitude.value = storage.substr(storage.length - 1, storage.length);
  modeldata.value = data.model;
}

function toThousands(num) {
  //千分位格式化
  return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
}
</script>

<style scoped>
@font-face {
  /* font-test*/
  font-family: ledfont;
  src: url("../../Assets/Fonts/UnidreamLED.ttf");
}

.admin-analysis-tako-root {
  padding: 20px;
}

.topdiv-wrapper {
  height: 150px;
  width: 20%;
  display: inline-block;
}

.topdivcss {
  margin: 0px 10px;
  background: #ffffff;
}

.toptitledivcss {
  height: 75px;
  line-height: 75px;
  text-align: center;
  font-size: 18px;
  color: #fff;
  background: #49cd9c;
}

.toptitlenumdivcss {
  height: 75px;
  line-height: 75px;
  text-align: center;
  font-size: 34px;
  font-family: "ledfont";
}

.toptitlenumdivapsncss {
  height: 75px;
  line-height: 75px;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  font-family: "Microsoft YaHei";
}
</style>
